import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["file", "modal", "form"]

  upload() {
    if (this.fileTarget.files.length === 0) return

    const modal = this.modalTarget.querySelector(":scope > div")
    if (modal) {
      $(modal).modal("show")
      setTimeout(() => this.formTarget.requestSubmit(), 300)
    } else {
      this.formTarget.requestSubmit()
    }
  }
}
